module.exports = __webpack_public_path__ + "static/media/wc_bnr.3e55fbcb.jpg";